import React from "react"
import autobind from "class-autobind"
import Positions from "../../../components/position/Positions"
import { IPosition } from "../../../models"
import * as api from "../../../api"
interface IProps {
    readonly: boolean
    clientId: string
}
interface IState {
    positions: IPosition[]
}


export default class ClinetDetailsPositions extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            positions: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.getPositions()
    }

    getPositions(cb: Function = null) {
        api.getClientPositions(this.props.clientId).then(res => {
            this.setState({ positions: res.data })
            cb && cb()
        })
    }


    render() {
        return (
            <Positions
                readonly={this.props.readonly}
                positions={this.state.positions}
                usablePositions={[]}
                handleAdd={(position, cb) =>
                    api.addClientPosition(this.props.clientId, position).then(() =>
                        this.getPositions(cb)
                    )
                }
                handleUpdate={(position, cb) =>
                    api.updateClientPosition(this.props.clientId, position).then(() =>
                        this.getPositions(cb)
                    )
                }
                handleDelete={(positions, cb) =>
                    api.deleteClientPositions(this.props.clientId, positions.map(item => item.Id)).then(() =>
                        this.getPositions(cb)
                    )
                }
            />
        )
    }
}
